import * as React from 'react'

class OnFormikValueChange extends React.Component<{
  formik: any
  onChange: any
}> {
  componentDidUpdate(prevProps) {
    const { values, touched, errors, isSubmitting } = prevProps.formik

    const {
      values: nextValues,
      touched: nextTouched,
      errors: nextErrors,
      isSubmitting: nextIsSubmitting,
    } = this.props.formik

    if (this.props.formik !== prevProps.formik) {
      this.props.onChange(
        {
          values,
          touched,
          errors,
          isSubmitting,
        },
        {
          values: nextValues,
          touched: nextTouched,
          errors: nextErrors,
          isSubmitting: nextIsSubmitting,
        }
      )
    }
  }

  render() {
    return null
  }
}

export default OnFormikValueChange



// WEBPACK FOOTER //
// ./src/components/OnFormikValueChange/OnFormikValueChange.tsx